import { Table, Tooltip } from "flowbite-react";

import { RequestItemType } from "./RequestItemType";
import { useUtils } from "../../../hooks/useUtils";

import { GrDocumentPdf } from "react-icons/gr";
import { MdDelete, MdEditSquare } from "react-icons/md";

interface ITableRowProps  {
    RequestItems: RequestItemType,
    editItem: (id: number) => void,
    handleDownload: (quoteID: number, quoteFilename: string) => void,
    deleteItem: (id: number) => void
}

const TableRow = ({RequestItems, editItem, handleDownload, deleteItem}: ITableRowProps) => {
    const helperUtils = useUtils(); 
    
    return (
        
            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell>
                    <a
                        className="text-cyan-600 hover:underline dark:text-cyan-500 cursor-pointer" onClick={() => editItem(RequestItems.id)}>
                        {RequestItems.name}
                    </a>
                </Table.Cell>
                <Table.Cell>
                    {RequestItems.supplier}
                </Table.Cell>
                <Table.Cell>
                    {RequestItems.supplierPartNo}
                </Table.Cell>
                <Table.Cell>
                    <div className="text-green-500">{helperUtils.convertToMoney(RequestItems.price_nzd)} (NZD)</div>                                                
                </Table.Cell>
                <Table.Cell>
                    <div className="text-blue-600 dark:text-green-700">
                        {helperUtils.formatURL(RequestItems.url)}
                    </div>
                </Table.Cell>                                            
                <Table.Cell>
                    {(RequestItems.with_quote == 1) && (<div className="text-red-800 dark:text-orange-500 flex items-center justify-center">
                        <Tooltip content="Download" style="dark">
                            <GrDocumentPdf className="h-5 w-5 text-sm cursor-pointer" onClick={() => handleDownload(RequestItems.quote.id, RequestItems.quote.filename)} />
                        </Tooltip>
                    </div>)}
                </Table.Cell>
                <Table.Cell>
                    <div className="font-thin text-base text-cyan-600 hover:underline dark:text-cyan-500 flex items-center mb-2">
                        <Tooltip content="Edit" style="dark">
                            <MdEditSquare className="cursor-pointer" onClick={() => editItem(RequestItems.id)}/>
                        </Tooltip>
                    </div>
                    <div className="font-thin text-base text-red-600 hover:underline dark:text-red-400 flex items-center">
                        <Tooltip content="Delete" style="dark">
                            <MdDelete className="cursor-pointer" onClick={() => deleteItem(RequestItems.id)} />
                        </Tooltip>
                    </div>
                </Table.Cell>
            </Table.Row>                  
    )
}

export default TableRow;